// extracted by mini-css-extract-plugin
module.exports = {"button":"S1wL6F","inner":"DDcdci"};